module.exports = __webpack_public_path__ + "static/media/0192_Small.de960f73.jpg";